import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const TitleTextInputStyled = styled.input`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.headingH3)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  border: none;
  word-break: break-word;
  width: ${(props) => props.width}ch;
  min-width: 175px;

  &::placeholder {
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  }

  &:focus-visible {
    outline: none;
  }

  background-color: transparent;
`;
